import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import Linked from '../../img/icon-linked.svg'
import Clipboard from '../../img/icon-survey.svg'
import { removeExtraneousState } from '../actions/savedState'
import { CopyToClipboard } from 'react-copy-to-clipboard'

class Share extends React.Component {
    static propTypes = {
        x: PropTypes.number,
        className: PropTypes.string
    }

    static defaultProps = {
        x: null,
        className: ''
    }

    constructor(props) {
        super(props)
        this.state = {
            isLoaded: false,
            shareUrl: null,
            error: null
        }
        this.copyLink = this.copyLink.bind(this)
        this.cancel = false
    }

    componentDidMount() {
        const host = window.location.origin
        const currentState = removeExtraneousState(this.props.state)
        axios.post('/state-url/', { state: currentState }).then(
            result => {
                if (this.cancel) {
                    return
                }

                this.setState({
                    isLoaded: true,
                    shareUrl: host.concat(`/s/${result.data}`)
                })
            },
            error => {
                this.setState({
                    isLoaded: true,
                    error
                })
            }
        )
    }

    componentWillUnmount() {
        this.cancel = true
    }

    copyLink = () => {
        const inputValue = document.getElementById('share-input')
        inputValue.focus()
        inputValue.select()
        const linkText = document.getElementById('share-text')
        // Text fade
        linkText.classList.add('share-text-animation')
        // Remove class so text fade will occur again if button clicked again
        setTimeout(function() {
            linkText.classList.remove('share-text-animation')
        }, 5100)
    }

    render() {
        const { x, className } = this.props
        const { error, isLoaded } = this.state

        if (error) {
            return <div>Error: {error.message}</div>
        }
        if (!isLoaded) {
            return (
                <div className={`share-content is-loading ${className}`} style={{ left: `${x - 325}px` }}>
                    <div className="share-container">
                        <div className="spinner">
                            <div className="bounce1" />
                            <div className="bounce2" />
                            <div className="bounce3" />
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div className={`share-content ${className}`} style={{ left: `${x - 325}px` }}>
                <h5 className="title is-5">Link</h5>
                <p>Save or send this link to save your work or share it with others.</p>
                <div className="share-container" style={{ marginTop: '10px' }}>
                    <span className="share-input-container">
                        <span className="link-icon">
                            <Linked />
                        </span>
                        <input
                            className="input share-input"
                            id="share-input"
                            style={{ width: '325px' }}
                            value={this.state.shareUrl}
                            readOnly
                        />
                    </span>
                    <CopyToClipboard text={this.state.shareUrl} onCopy={this.copyLink}>
                        <span className="clip-icon">
                            <Clipboard />
                        </span>
                    </CopyToClipboard>
                </div>
                <p className="share-text" id="share-text">
                    Link copied to clipboard
                </p>
            </div>
        )
    }
}

const mapStateToProps = state => ({ state })

export default connect(mapStateToProps, null)(Share)
